import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { callEndpoint, telemetry } from '../../../../services/backend';
import { transitionToPreviousRoute } from '../../../../services/route/route-navigation';
import { setMarkerSummaryDetails } from '../../../../services/store/modules/app-controls';
import BasicDrawerLayout from '../../../layouts/BasicDrawerLayout/BasicDrawerLayout';
import LogoSpinner from '../../../shared/_deprecated/components/LogoSpinner/LogoSpinner';
import { getMapMarkerIconConfig } from '../../../shared/vector-images';
import MarkerContainerView from '../MarkerContainer/MarkerContainerView';

const MarkerSummaryDetails = ({ dispatchSetMarkerSummaryDetails, url }) => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({});

  useEffect(() => {
    let isMounted = true;

    const getData = async () => {
      setIsLoading(true);
      telemetry(telemetry.DEBUG, '[MarkerSummaryDetails.getItem] called');

      // Get the marker details
      try {
        const item = await callEndpoint(
          callEndpoint.endpoints.getRegulationById,
          {
            ':id': encodeURIComponent(url),
          },
        );
        const {
          details: {
            title,
            icon,
            image,
            description,
            links,
            customDescription,
            checkboxes,
            banner,
          },
          centroid,
        } = item;

        const formattedLatLon = {
          lat: +centroid.coordinates[1].toFixed(4),
          lon: +centroid.coordinates[0].toFixed(4),
        };

        const informationButtons =
          links && links.filter((link) => link.type === 'informationButton');

        setData({
          title,
          formattedLatLon,
          icon,
          checkboxes,
          banner,
          description,
          customDescription,
          image,
          informationButtons,
        });
      } catch (currentError) {
        if (isMounted) {
          setError({
            status: 204,
            message:
              currentError && currentError.message
                ? currentError.message
                : 'No marker details found',
          });
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };
    dispatchSetMarkerSummaryDetails();
    getData();

    return () => {
      telemetry(telemetry.DEBUG, '[MarkerSummaryDetails.useEffect] unmounted');
      isMounted = false;
    };
  }, [setData, setIsLoading, setError, dispatchSetMarkerSummaryDetails, url]);

  return (
    <BasicDrawerLayout onBack={() => transitionToPreviousRoute()}>
      {!error && isLoading && <LogoSpinner />}
      {!isLoading && !error && (
        <MarkerContainerView
          title={data.title}
          formattedLatLon={data.formattedLatLon}
          markerIcon={getMapMarkerIconConfig(data.icon)}
          checkboxes={data.checkboxes}
          banner={data.banner}
          description={data.description}
          customDescription={data.customDescription}
          image={data.image}
          informationButtons={data.informationButtons}
          sharePath={`marker/summary/details/${url}`}
          shareText={`Check out this ${data.title} on Deckee`}
          buttonLabel={data.buttonLabel}
          buttonHref={data.buttonHref}
          id={null}
          markerType={null}
        />
      )}
    </BasicDrawerLayout>
  );
};

MarkerSummaryDetails.propTypes = {
  url: PropTypes.string.isRequired,

  dispatchSetMarkerSummaryDetails: PropTypes.func.isRequired,
};

MarkerSummaryDetails.defaultProps = {};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  dispatchSetMarkerSummaryDetails: () => dispatch(setMarkerSummaryDetails({})),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MarkerSummaryDetails);
